export function isFunction (val) {
  return typeof val === 'function'
}

export function isNumber(val) {
  return typeof val === 'number'
}

export function spliceArray(arr, val) {
  const index = arr.indexOf(val)
  if (index > -1) {
    arr.splice(index, 1)
  }
}


export function logError (err, logConf = '') {
  if (typeof console !== 'undefined') {
    console.error('%c【KyeTable2】' + err, logConf)
  } else {
    throw err
  }
}


// 获取数据
export const getValue = (key, obj, getSourceOfKey) => {
  if (!key || !obj) {
    return ''
  }
  let source = null
  // 解析键的属性和数组索引
  const parseKey = (k) => {
    const index = k.indexOf('[')
    return {
      prop: index > 0 ? k.substr(0, index) : k,
      arrayIndex: index > 0 ? +k.substring(index + 1, k.length - 1) : undefined,
    }
  }

  // 处理每个键的情况
  const handleKey = (s, k, isLast) => {
    const { prop, arrayIndex } = parseKey(k)
    const value = s[prop]
    source = s
    if (isLast) {
      return arrayIndex !== undefined ? (value || [])[arrayIndex] : value
    }
    return arrayIndex !== undefined ? (value || [])[arrayIndex] || {} : value || {}
  }

  if (key.includes('.')) {
    const keys = key.split('.')
    const value = keys.reduce((s, k, i) => handleKey(s, k, i === keys.length - 1), obj)
    return getSourceOfKey ? { source, value } : value
  } else {
    const value = handleKey(obj, key, true)
    return getSourceOfKey ? { source, value } : value
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/utils/tools.js